<template>
  <div class="knw_message_body">
    <div class="message_filedownload">
      <IconFile width="24" height="24" />
      <div class="message_filedownload_metainfos">
        <span>{{ filename }}</span>
        <small
          v-if="
            fileinfo?.filetype || fileinfo?.filesize
          "
        >
          {{ fileinfo.filetype }}

          {{
            fileinfo.filetype && fileinfo.filesize
              ? '-'
              : ''
          }}
          <span v-if="fileinfo?.filesize && !Number.isNaN(fileinfo.filesize)">
            {{ fileinfo.filesize }}
          </span>
        </small>
      </div>
      <button class="message_filedownload_button" @click="downloadFile">
        <IconDownloadFile width="18" height="18" />
        Download
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconDownloadFile from '@/svg/IconDownloadFile.vue';
import IconFile from '@/svg/IconFile.vue';
import { saveAs } from 'file-saver';
import { computed } from 'vue';
import { getFilenameFromURL } from '@/common/utils';

const props = defineProps<{
  fileinfo: {
    filename: string;
    filetype: string;
    filesize: string;
    fileUrl: string;
  }
}>()

const filename = computed(() => {
  if (props.fileinfo?.filename) {
    return props.fileinfo.filename;
  }
  const urlFilename = getFilenameFromURL(props.fileinfo.fileUrl);
  if (urlFilename) {
    return urlFilename;
  }
  return 'Dateidownload';
});

const downloadFile = () => {
  saveAs(props.fileinfo.fileUrl, filename.value);
};
</script>

<style scoped lang="scss">
.knw_message_body {
  // TODO Do we need the paddings? Can we just make it full width?

  // padding-right: 34px;
  // padding-left: 57px;
  // margin-bottom: 7px;
}

.message_filedownload {
  background: var(--moin-message-bot-background, $kw-global-background-white);
  color: var(--moin-message-bot-textcolor, $kw-global-textcolor);
  fill: var(--moin-message-bot-textcolor, $kw-global-textcolor);
  border: 1px solid;
  border-color: var(--moin-message-bot-bordercolor, transparent);

  border-radius: var(--kw-widget-global-borderradius-outer);
  width: 100%;
  display: grid;
  gap: 8px;
  grid-template-columns: 32px 1fr auto;
  align-items: center;
  padding: 8px;
  text-align: left;

  >svg {
    // fill: var(--moin-message-bot-subtextcolor, $kw-global-textcolor-light);
    fill: var(--moin-message-bot-textcolor, $kw-global-textcolor);
    align-self: center;
    justify-self: center;
  }
}

.message_filedownload_metainfos {
  display: grid;

  span,
  small {
    line-height: 1.2;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  small {
    color: var(--moin-message-bot-subtextcolor, $kw-global-textcolor-light);
  }
}

.message_filedownload_button {
  @include default-font;
  @include default-focus;

  position: relative;
  text-decoration: none;
  appearance: none;
  background: $kw-global-background-white;
  color: $kw-global-textcolor;
  box-shadow: none;
  border-radius: var(--kw-widget-global-borderradius-inner);
  border: 1px solid var(--moin-widget-button-bordercolor);

  height: 32px;
  max-width: calc(100% - 18px); /* 8px X padding + 2px X border */
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color .2s ease-in-out;

  margin: 0;
  padding: 0 8px;
  gap: 0.5rem;

  box-sizing: content-box;

  text-transform: none;
  font-weight: 400;
  font-size: 1.5rem;

  &:hover {
    cursor: pointer;
    border-color: $kw-default-button-border-color-hover;
    transition: border-color .2s ease-in-out;
  }
}
</style>
